export  function ScrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "instant"
    });
  }

 